export default __webpack_public_path__ + "static/media/Preview360.96910508.CSS";